<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <jm-crumbs/>
        <div class="table-agile-info">
          <el-row
            class="rows h-rows"
            :gutter="10">
            <el-col
              :xs="24"
              :sm="24"
              :md="6"
              :lg="5">
              <div class="rows-div">
                <p>
                  <span class="s_title">签约量</span>
                  <span class="s_right">{{ constDict.nowMonth }}</span>
                </p>
                <div class="chart-div h-bar">
                  <bi-bar-h
                    :data="signNumData.data"
                    :options="signNumData.options"
                    :refresh.sync="signNumData.refresh"
                    @reload="getSignNum"/>
                </div>
              </div>
            </el-col>
            <el-col
              :xs="24"
              :sm="24"
              :md="12"
              :lg="14">
              <div class="rows-div">
                <p>
                  <span class="s_title">销售额</span>
                  <span class="s_right">{{ constDict.nowMonth }}</span>
                </p>
                <div
                  class="prosses-div"
                  v-if="moneyData.ex">
                  <el-row :gutter="10">
                    <el-col
                      :xs="12"
                      :sm="5"
                      :md="5"
                      :lg="5">
                      <div class="text-right">
                        <span class="title-span">本月销售额(万元)</span><br>
                        <span class="num-span">{{ moneyData.ex.real }}</span>
                      </div>
                    </el-col>
                    <el-col
                      :xs="0"
                      :sm="12"
                      :md="12"
                      :lg="12">
                      <span class="prosses-span">
                        <em class="fc-em">{{ moneyData.ex.title }}</em>
                        <em class="prosses-em"><i :style="{ width:`${moneyData.ex.point}%` }"/></em>
                      </span>
                    </el-col>
                    <el-col
                      :xs="10"
                      :sm="5"
                      :md="5"
                      :lg="5">
                      <div>
                        <span class="title-span">目标销售额(万元)</span><br>
                        <span class="num-span">{{ moneyData.ex.target }}</span>
                      </div>
                    </el-col>
                    <el-col
                      :xs="2"
                      :sm="2"
                      :md="2"
                      :lg="2">
                      <span class="prosses-span">
                        <a
                          href="/frontend/bi/departmentMoney"
                          target="_blank"><el-button><i
                            class="el-icon-edit"
                            style="font-size: 18px;"/></el-button></a>
                      </span>
                    </el-col>
                  </el-row>
                </div>
                <div class="chart-div">
                  <bi-line
                    :data="moneyData.data"
                    :data1="moneyData.data1"
                    :options="moneyData.options"
                    :refresh="moneyData.refresh"
                    @reload="getMoney"/>
                </div>
              </div>
            </el-col>
            <el-col
              :xs="24"
              :sm="24"
              :md="6"
              :lg="5">
              <div class="rows-div">
                <p>
                  <span class="s_title">资源量</span>
                  <span class="s_right">{{ constDict.nowMonth }}</span>
                </p>
                <div class="chart-div h-bar">
                  <bi-bar-h
                    :data="regNumData.data"
                    :options="regNumData.options"
                    :refresh.sync="regNumData.refresh"
                    @reload="getRegNum"/>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row
            class="rows"
            :gutter="10">
            <el-col
              :xs="24"
              :sm="24"
              :md="15"
              :lg="15">
              <div class="rows-div">
                <p>
                  <span class="s_title">趋势</span>
                  <span class="s_right">时间：
                    <el-radio-group
                      v-if="constDict.date3"
                      slot="head"
                      v-model="timeLineType"
                      size="mini"
                      @change="getTimeLine">
                      <el-radio-button
                        v-for="(option, index) in constDict.date3"
                        :key="index"
                        :label="index">{{ option }}</el-radio-button>
                    </el-radio-group>
                  </span>
                </p>
                <div class="chart-div">
                  <bi-line
                    :data="timeLineData.data"
                    :data1="timeLineData.data1"
                    :options="timeLineData.options"
                    :refresh="timeLineData.refresh"
                    @reload="getTimeLine"/>
                </div>
              </div>
            </el-col>
            <el-col
              :xs="24"
              :sm="24"
              :md="9"
              :lg="9">
              <div class="rows-div">
                <p>
                  <span class="s_title">签约转化率</span>
                  <span class="s_right">{{ constDict.nowMonth }}</span>
                </p>
                <div class="chart-div">
                  <bi-bar-line
                    :data="turnoverRateData.data"
                    :data1="turnoverRateData.data1"
                    :options="turnoverRateData.options"
                    :refresh="turnoverRateData.refresh"
                    @reload="getTurnoverRate"/>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row
            class="rows"
            :gutter="10">
            <el-col
              :xs="24"
              :sm="24"
              :md="24"
              :lg="24">
              <div class="rows-div">
                <p>
                  <span class="s_title">渠道转化</span>
                  <el-tooltip
                    placement="top"
                    effect="light">
                    <div slot="content">
                      数据量过多时，可以使用鼠标左右拖动下方数据区域
                    </div>
                    <span><i class="el-icon-caret-left blue"/><i class="el-icon-caret-right blue"/></span>
                  </el-tooltip>
                  <el-tooltip
                    placement="right"
                    effect="light">
                    <div slot="content">
                      资源量：注册时间为当前日期的资源数<br>
                      签约量：签约时间为当前日期的签约资源数<br>
                      转化率：签约量/资源量
                    </div>
                    <i class="el-icon-question blue"/>
                  </el-tooltip>
                  <span class="s_right">时间：
                    <el-radio-group
                      v-if="constDict.date4"
                      slot="head"
                      v-model="channelType"
                      size="mini"
                      @change="getChannelData">
                      <el-radio-button
                        v-for="(option, index) in constDict.date4"
                        :key="index"
                        :label="index">{{ option }}</el-radio-button>
                    </el-radio-group>
                  </span>
                  <span
                    class="s_right"
                    v-if="channelSort.options.length">排序方式：
                    <el-select
                      v-model="channelSort.value"
                      placeholder="请选择排序方式"
                      size="mini"
                      class="jm-input135"
                      @change="setChannelSort">
                      <el-option
                        v-for="item in channelSort.options"
                        :key="item"
                        :label="item"
                        :value="item"/>
                    </el-select>
                  </span>
                </p>
                <div class="chart-div">
                  <bi-bar-line
                    :data="channelData.data"
                    :data1="channelData.data1"
                    :options="channelData.options"
                    :refresh="channelData.refresh"
                    @reload="getChannelData"/>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BiBar from '@/components/charts/biBar';
import BiBarH from '@/components/charts/biBarH';
import BiLine from '@/components/charts/biLine';
import BiBarLine from '@/components/charts/biBarLine';
import common from '@/pages/bi/common';

let constDict = {
  date4: {},
  date3: {}
};

export default {
  mixins: [common],
  data() {
    return {
      constDict,
      signNumData: {
        options: {
          domainX: null
        },
        refresh: 1
      },
      moneyData: {
        options: {
          domainX: null
        },
        refresh: 1
      },
      regNumData: {
        options: {
          domainX: null
        },
        refresh: 1
      },
      timeLineType: 2,
      timeLineData: {
        options: {
          domainX: null
        },
        refresh: 1
      },
      turnoverRateData: {
        options: {
          domainX: null
        },
        refresh: 1
      },
      channelType: 3,
      channelData: {
        options: {
          domainX: null
        },
        refresh: 1
      },
      channelSort: {
        options: [],
        value: '注册量'
      },
    };
  },
  components: {
    BiBarLine, BiBar, BiBarH, BiLine
  },
  created() {
    this.$http
      ._get({
        url: '/index/b_i_boss_view/index'
      })
      .then(({ data }) => {
        this.constDict.date4 = data.date4;
        this.constDict.date3 = data.date3;
        this.constDict.nowMonth = data.nowMonth;
        this.init();
      });
  },
  methods: {
    init() {
      this.getChannelData();
      this.getTimeLine();
      this.getTurnoverRate();
      this.getRegNum();
      this.getMoney();
      this.getSignNum();
    },
    // 签约量
    getSignNum() {
      this.fetchData({
        url: '/index/b_i_boss_view/getSignNum',
        field: 'signNumData',
        option: {
          margin: {
            top: 15, right: 20, bottom: 5, left: 0
          },
          colors: ['#FF9F00'],
          barWidth: '70',
          domainType: 'string',
          groupType: true,
        }
      });
    },
    // 销售额
    getMoney() {
      this.fetchData({
        url: '/index/b_i_boss_view/getMoney',
        field: 'moneyData',
        option: {
          margin: {
            top: 30, right: 30, bottom: 20, left: 30
          },
          labelWidthPercent: 50,
          colors: ['#409EFF', '#BD48FF'],
          domainType: 'time',
          isArea: 1,
          tooltipType: 'day',
          exY: '万'
        }
      });
    },
    // 资源量
    getRegNum() {
      this.fetchData({
        url: '/index/b_i_boss_view/getRegNum',
        field: 'regNumData',
        option: {
          margin: {
            top: 15, right: 20, bottom: 5, left: 0
          },
          colors: ['#FF6153'],
          barWidth: '70',
          domainType: 'string',
          groupType: true,
        }
      });
    },
    // 趋势
    getTimeLine() {
      // let tooltipType = ['day', 'month', 'year'];
      let type = 'month';// tooltipType[this.timeLineType];
      this.fetchData({
        url: '/index/b_i_boss_view/getNumTimeLine',
        field: 'timeLineData',
        param: { date_type: this.timeLineType },
        option: {
          margin: {
            top: 30, right: 30, bottom: 20, left: 50
          },
          colors: ['#FF6153', '#FF9F00', '#BD48FF'],
          domainType: 'time',
          exY1: '%',
          tooltipType: type
        }
      });
    },
    // 签约转化率
    getTurnoverRate() {
      this.fetchData({
        url: '/index/b_i_boss_view/getTurnoverRate',
        field: 'turnoverRateData',
        option: {
          margin: {
            top: 30, right: 30, bottom: 20, left: 0
          },
          labelWidthPercent: 50,
          colors: ['#409EFF', '#BD48FF'],
          barWidth: '70',
          domainType: 'string',
          groupType: true,
          lineStyle: 0,
          exY: '%',
          exY1: '%'
        }
      });
    },
    // 渠道转化
    getChannelData() {
      this.fetchData({
        url: '/index/b_i_boss_view/getChannel',
        field: 'channelData',
        param: { date_type: this.channelType },
        option: {
          margin: {
            top: 30, right: 30, bottom: 20, left: 0
          },
          labelWidthPercent: 100 / 12,
          colors: ['#FF6153', '#FF9F00', '#BD48FF'],
          barWidth: 30,
          domainType: 'string',
          groupType: true,
          exY1: '%'
        },
        sort: 'channelSort'
      });
    },
    setChannelSort() {
      this.channelData = this.sortData(this.channelData, this.channelSort.value);
    },
  },
  watch: {
    countryId() {
      this.$nextTick(this.init);
    }
  }
};
</script>

<style scoped>
.fc-em {
  color: #3f3f3f;
}
.text-right {
  text-align: right;
}
.s_right {
  float: right;
}
.rows:last-child {
  /*margin-bottom: 200px;*/
}
.rows .rows-div {
  background-color: #FFF;
  border-radius: 5px;
  margin-top: 10px;
  padding: 10px 20px 20px 20px;
}
.rows .rows-div p {
  border-bottom: solid 1px #CCC;
  padding: 10px 0px;
}
.rows.h-rows .rows-div {
  height: 450px;
}
.rows.h-rows .rows-div .prosses-div {
  height: 130px;
}
.rows.h-rows .rows-div .prosses-div .title-span {
  margin-top: 20px;
  font-size: 18px;
  font-weight: 600;
  display: block;
}
.rows.h-rows .rows-div .prosses-div .num-span {
  color: #FF6153;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 2px;
}
.rows.h-rows .rows-div .prosses-span {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100px;
}
.rows.h-rows .rows-div .prosses-span em.prosses-em {
  width: 80%;
  height: 20px;
  border: #f3f3f3 solid 2px;
  border-radius: 20px;
}
.rows.h-rows .rows-div .prosses-span em.prosses-em i {
  display: block;
  height: 100%;
  background-color: #409EFF;
  border-radius: 20px;
}
.rows .rows-div .chart-div {
  height: 250px;
}
.rows .rows-div .chart-div.h-bar {
  height: 380px;
}
.s_title {
  font-size: 18px;
}
.blue {
  color: #409EFF;
}
</style>
